import {CartItemType, useShoppingCartStore} from "../../../shoppingCart/model/store";
import {GoodsType} from "../../../../entities/goods/model/types/goods-type";


/**
 * useToggleCart.
 *  Реализация фичи для товара: добавление/удаление из корзины.
 *  Проверяет есть ли текущий товар в корзине
 *
 * @returns {{ isInCart: boolean, toggle: () => void }}
 * - Возварщает
 *  isInCart - флаг есть ли товар в корзине
 *  toggle   - метод который добавит или удалит товар из козины
 */

export const useToggleCart = (goods: GoodsType) => {
    const isViewShoppingCart = useShoppingCartStore((state) => state.isViewShoppingCart);
    const setViewShoppingCart = useShoppingCartStore((state) => state.setViewShoppingCart);
    const addItem = useShoppingCartStore((state) => state.addToItem);
    const removeItem = useShoppingCartStore((state) => state.removeItem);
    const isInCart = useShoppingCartStore((state) => state.isInCart(goods.id));

    const toggle = () => {
        const cartItem: CartItemType = {
            id: goods.id,
            name: goods.name,
            description: goods.description,
            quantity: 1,
            price: goods.price,
            picture: ''
        }
        if (isInCart) {
            removeItem(goods.id);
        } else {
            addItem(cartItem);
            if (!isViewShoppingCart) setViewShoppingCart(true);
        }
    };

    return {
        isInCart,
        toggle,
    };
};